import * as React from "react";
import { ComponentTypes, DirectoryTreeType } from "../../../config/config";
import { Loader } from "../../Loader";
import { connect, ConnectedProps } from "react-redux";
import { addWorkingDirectory, setWorkingDirectories } from "../../../redux/modules/workingDirectory";
import { getSites } from "../../../redux/modules/sharepointInfo";
import { getTeams } from "../../../redux/modules/teams";
import { addRegionalSettings } from "../../../redux/modules/regional";
import { RootState } from "../../../redux";
import { ActionButton, Spinner, SpinnerSize } from "@fluentui/react";
import { initialFolderOptionPanelInfoSetting, validSaveModes } from "../../../config/constants";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import FolderOptionPanel from "../../panels/FolderOptionPanel";
import { FolderTypeEnum } from "../../enums/FolderTypeEnum";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { expanderConstants } from "../../../redux/models/constants/expanders";
import { setSearch } from "../../../redux/modules/search";
import ExpanderWithSubtitle from "../ExpanderWithSubtitle";
import FileAndFoldersSharepointSearch from "../../file/fileAndFoldersSharepointSearch";
import { ISiteInfo, ISiteInfoLocation, ISiteSearchResult } from "../../../interfaces/ISiteInfo";
import authModule from "../../../../../utilities/AuthModule";
import { SharepointSpServices } from "../../../services/SharepointSpServices";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { isMobile } from "../../../styles/mobileStyles";
import { getHubSiteSites, getSharePointDocumentLibraries, getSharePointSubsite, getTeamChannels, searchSharePointSites } from "../../../services/GraphService";
import { logger } from "../../../../../utilities/logger";
import generalModule from "../../../../../utilities/GeneralModule";
import { setContentManagerSearchValue, setIsContentManagerContentLoading, toggleContentManagerReload } from "../../../redux/modules/contentManagerDirectory";
import { ITeamChannelDto, ITeamChannelLocationDto } from "../../../interfaces/services/ITeamChannelDto";
import { IFolderLocation, ISharepointDocumentLocation } from "../../../interfaces/ISharepointDocument";
import { generateRandomString } from "../../helpers/randomStringHelper";
import { buildWorkingDirectoryFromTree, calculateLocationHeight, findWorkingDirectories, openTreeFolderOptions } from "../../helpers/treeHelperGeneral";
import { SharePointDocumentLibraryItem } from "../../_v2/components/Explorer/FolderView/SharePointDocumentLibraryItem";
import { FolderViewWrapper } from "../../helpers/folderViewWrapper";
import { getListSettings, getUserEffectivePermissions } from "../../../services/SharePointRestServices";
import { setCanViewFolder } from "../../../redux/modules/currentSharepointFolder";
import { decrementAmountOfLoaders, incrementAmountOfLoaders } from "../../../redux/modules/loader";
import savingLocationStructureModule from "../../../../../utilities/SavingLocationStructureModule";
import { TeamChannelItem } from "../../_v2/components/Explorer/FolderView/TeamChannelItem";
import { useLazyRenderListAsStreamTreeQuery } from "../../_v2/redux/api/sharepoint/api-sharepoint-slice";
import { SharePointFolderItem } from "../../_v2/components/Explorer/FolderView/SharePointFolderItem";
import { SiteItem } from "../../_v2/components/Explorer/FolderView/SiteItem";
import { SharePointSiteHelper } from "../../../../../utilities/SharePointSiteHelper";
import { IGraphSearchPager } from "../../../interfaces/IGraphSearchPager";
import SubTitleRefreshButton from "../SubTitleRefreshButton";
import { ChevronDoubleDown20Regular } from "../../_v2/components/SvgIcons/ChevronDoubleDown20Regular";

const mapDispatchToProps = {
  addWorkingDirectory,
  setWorkingDirectories,
  getTeams,
  setSearch,
  getSites,
  addRegionalSettings,
  setContentManagerSearchValue,
  setIsContentManagerContentLoading,
  incrementAmountOfLoaders,
  setCanViewFolder,
  decrementAmountOfLoaders,
  toggleContentManagerReload
};

const mapStateToProps = (state: RootState) => {
  return {
    amountOfLoaders: state.loading.amountOfLoaders,
    reload: state.reload.toggle,
    searchValue: state.search.searchValue.value,
    sites: state.sharePointInfo.sites,
    isSitesLoading: state.sharePointInfo.isSitesLoading,
    sitesPageData: state.sharePointInfo.pageData,
    teams: state.teams.teams,
    regionalSettings: state.regionalSettings,
    allowedSiteCollections: state.tenantInfo.allowedSiteCollections,
    hideTeamsSitesInSharePoint: state.tenantInfo?.hideTeamsSitesInSharePoint,
    hideDocumentLibrariesInTeams: state.tenantInfo?.hideDocumentLibrariesInTeams,
    tenantSiteConfig: state.tenantInfo?.sites,
    userSettings: state.user.settings,
    contentManagerFilterValue: state.contentManagerDirectory.filterValue,
    user: state.user,
    mode: state.mode.mode,
    hasFileSelected: state.files.files.some(file => file.isSelected),
    lastServerFetch_sites: state.sharePointInfo.lastServerFetch,
    lastServerFetch_teams: state.teams.lastServerFetch,
    lastCacheFetch_sites: state.sharePointInfo.lastCacheFetch,
    lastCacheFetch_teams: state.teams.lastCacheFetch,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface SharePointSiteProps extends PropsFromRedux {
  hide: boolean;
  isDocubirdManagedLocation: boolean;
  isGeneralSearchRequest?: boolean;
  isSearchingFilesAndFolders?: boolean;
  hideGeneralSearchElement?: () => void;
}

const SharePointSite: React.FunctionComponent<SharePointSiteProps> = ({
  hide,
  amountOfLoaders,
  addWorkingDirectory,
  setWorkingDirectories,
  getSites,
  getTeams,
  setSearch,
  reload,
  sites,
  isSitesLoading,
  sitesPageData,
  teams,
  searchValue,
  regionalSettings,
  addRegionalSettings,
  allowedSiteCollections,
  userSettings,
  contentManagerFilterValue,
  setContentManagerSearchValue,
  setIsContentManagerContentLoading,
  user,
  mode,
  hasFileSelected,
  incrementAmountOfLoaders,
  setCanViewFolder,
  decrementAmountOfLoaders,
  toggleContentManagerReload,
  lastServerFetch_sites,
  lastServerFetch_teams,
  lastCacheFetch_sites,
  lastCacheFetch_teams,
  hideTeamsSitesInSharePoint,
  hideDocumentLibrariesInTeams,
  tenantSiteConfig,
  isGeneralSearchRequest,
  isSearchingFilesAndFolders,
  hideGeneralSearchElement,
  isDocubirdManagedLocation
}: SharePointSiteProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const [folderOptionPanelInfo, setFolderOptionPanelInfo] = React.useState<IFolderPanelInfo>(initialFolderOptionPanelInfoSetting);
  const [siteSearchResult, setSiteSearchResult] = React.useState<ISiteSearchResult>();
  const [isSearching, setIsSearching] = React.useState<boolean>(false);
  const [isSearchingContent, setIsSearchingContent] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isReloading, setIsReloading] = React.useState<boolean>(false);
  const [isFileOrFolderSearchResultsAvailable, setIsFileOrFolderSearchResultsAvailable] = React.useState<boolean>(false);
  const [combinedSitesAndTeams, setCombinedSitesAndTeams] = React.useState<ISiteInfoLocation[]>([]);
  const [siteItems, setSiteItems] = React.useState<JSX.Element[]>([]);
  const [locationHeight, setLocationHeight] = React.useState<number>(160);
  const [dataFetchedFromCacheAndRemote, setDataFetchedFromCacheAndRemote] = React.useState<boolean>(false);

  const isFirstRun = React.useRef(true);
  const compareWithCachedSites = React.useRef(false);
  const hasSearched = React.useRef(false);
  const selectedItem = React.useRef(null);
  const hidden = React.useRef<boolean>(hide);
  const allowSiteScroll = React.useRef<boolean>(false);

  const [getListAsStreamTree] = useLazyRenderListAsStreamTreeQuery();

  React.useEffect(() => {
    if (lastServerFetch_sites && lastServerFetch_teams && lastCacheFetch_sites & lastCacheFetch_teams) {
      setDataFetchedFromCacheAndRemote(true);
    }
  }, [lastServerFetch_sites, lastServerFetch_teams, lastCacheFetch_sites, lastCacheFetch_teams]);

  React.useEffect(() => {
    if (!sites) {
      getSites(allowedSiteCollections, null, true, true);
    }
  }, []);

  React.useEffect(() => {
    hidden.current = hide;
  }, [hide]);

  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (hidden.current || generalModule.isInConentMangerMode()) return;
    getSites(allowedSiteCollections);
    getTeams();
  }, [reload]);

  React.useEffect(() => {
    if (sitesPageData?.moreResultsAvailable || SharePointSiteHelper.hubSites.length > 0) {
      const setupAsyncWrapper = async () => {
        if (!searchValue && !hasSearched.current) return;
        if (!searchValue && hasSearched.current) {
          setSiteSearchResult(null);
          UpdateIsFileOrFolderSearchResultsAvailable(false);
          return;
        }

        hasSearched.current = true;
        await searchSites(searchValue);
      };
      setupAsyncWrapper();
    }
  }, [searchValue]);

  React.useEffect(() => {
    if (sitesPageData?.moreResultsAvailable || SharePointSiteHelper.hubSites.length > 0) {
      if (!contentManagerFilterValue && !hasSearched.current) return;
      if (!contentManagerFilterValue && hasSearched.current) {
        setSiteSearchResult(null);
        return;
      }

      hasSearched.current = true;

      (async () => {
        await searchSites(contentManagerFilterValue);
      })();
    }
  }, [contentManagerFilterValue]);

  const getTreeLocations = React.useCallback((): any[] => {
    return combinedSitesAndTeams;
  }, [combinedSitesAndTeams]);

  const UpdateIsFileOrFolderSearchResultsAvailable = (resultsAvailable: boolean) => {
    setIsFileOrFolderSearchResultsAvailable(resultsAvailable);
  }

  const openFolderOptions = (site: any) => {
    const teamSite = teams?.find(team => team.siteId === site.id || team.siteId === site.siteId);

    let locations: IPageSettings[];
    if (isGeneralSearchRequest || generalModule.isInConentMangerMode()) {
      locations = [
        {
          type: isDocubirdManagedLocation ? ComponentTypes.Docubird : ComponentTypes.SharePoint,
          id: "1",
          directory: "",
          displayName: isDocubirdManagedLocation ? ComponentTypes.Docubird : ComponentTypes.SharePoint,
          webUrl: "",
        },
        {
          id: teamSite && teamSite.id,
          type: ComponentTypes.SharePointDocuments,
          siteId: !teamSite ? site.id : teamSite.siteId,
          siteDisplayName: !teamSite ? site.name : teamSite.displayName,
          webUrl: !teamSite ? site.webUrl : teamSite.webUrl,
          directory: "",
          DocumentLibrary: "",
          teamGroupId: teamSite && teamSite.id,
          displayName: !teamSite ? site.name : teamSite.displayName,
          isSharedTeam: teamSite?.isSharedTeam
        }
      ]
    }

    if (teamSite) {
      setFolderOptionPanelInfo({
        isOpen: true,
        folder: { driveId: null, name: teamSite.displayName, id: teamSite.id, siteId: teamSite.siteId, isSharedTeam: teamSite.isSharedTeam },
        folderType: FolderTypeEnum.teamMainSite,
        webUrl: teamSite.webUrl,
        locations: locations
      });
    } else {
      setFolderOptionPanelInfo({
        isOpen: true,
        folder: { driveId: null, name: site.name, id: site.id },
        folderType: site.isHub
          ? FolderTypeEnum.sharepointHubSite
          : (isDocubirdManagedLocation ? FolderTypeEnum.docubird : FolderTypeEnum.sharepointSite),
        webUrl: site.webUrl,
        locations: locations
        // isTeamsSiteInsideSharepoint: teams?.some(team => team.siteId === site.id)
      });
    }
  };

  const addDirectory = React.useCallback(async (item: ISiteInfoLocation) => {
    let directoryToAdd: IPageSettings = {
      id: item.id,
      type: ComponentTypes.SharePointDocuments,
      siteId: item.siteId ?? item.id,
      siteDisplayName: item.name,
      webUrl: item.webUrl,
      directory: "",
      DocumentLibrary: "",
      displayName: item.name,
      isHub: item.isHub,
      hubId: item.hubId,
      parentHubId: item.parentHubId
    };

    // const teamSite = teams?.find(team => team.siteId === item.id);
    const teamSite = teams?.find(team => team.siteId === item.siteId || team.siteId === item.id);
    if (teamSite) {
      directoryToAdd.teamGroupId = teamSite.id;
      directoryToAdd.teamDriveId = teamSite.driveId;
      directoryToAdd.isSharedTeam = teamSite.isSharedTeam;
    }

    if (isGeneralSearchRequest || generalModule.isInConentMangerMode()) {
      if (generalModule.isInConentMangerMode()) setContentManagerSearchValue("");
      if (isGeneralSearchRequest && hideGeneralSearchElement) hideGeneralSearchElement();
      setWorkingDirectories([
        {
          type: isDocubirdManagedLocation ? ComponentTypes.Docubird : ComponentTypes.SharePoint,
          id: "1",
          directory: "",
          displayName: isDocubirdManagedLocation ? ComponentTypes.Docubird : ComponentTypes.SharePoint,
          webUrl: "",
        },
        directoryToAdd
      ]);
    }
    else {
      setSearch("");
      addWorkingDirectory(directoryToAdd);
    }

    if (!teamSite?.isSharedTeam) {
      await setupReduxRegionalSettings(item.webUrl);
    }
  }, [teams, isDocubirdManagedLocation]);

  const setupReduxRegionalSettings = async (webUrl: string) => {
    const isAlreadySetup = regionalSettings[webUrl];
    if (!isAlreadySetup) {
      const accessToken = await authModule.getSharePointAccessToken();
      const sharepointSpService = new SharepointSpServices(webUrl, accessToken);
      const regionalSettings = await sharepointSpService.getSiteRegionalSettings();
      if (regionalSettings) {
        addRegionalSettings({ ...regionalSettings, webUrl: webUrl });
      }
    }
  };

  const loadMoreSites = async () => {
    getSites(allowedSiteCollections, sitesPageData);
  }

  const searchSites = async (searchValue: string, pageData?: IGraphSearchPager) => {
    setIsSearching(true);
    try {
      let searchResult: ISiteSearchResult = await searchSharePointSites({
        query: searchValue + "*",
        from: pageData?.from,
        allowedSites: allowedSiteCollections
      });

      if (pageData?.moreResultsAvailable) {
        setSiteSearchResult(prevSiteSearchResult => {
          searchResult.sites = (prevSiteSearchResult?.sites ?? []).concat(searchResult?.sites ?? []);
          SharePointSiteHelper.configureManagesSites(searchResult.sites);
          return searchResult;
        });
      }
      else {
        SharePointSiteHelper.configureManagesSites(searchResult?.sites);
        setSiteSearchResult(searchResult);
      }
    } catch (error) {
      logger(error, "SharePointSite.tsx (searchSites)");
    }
    setIsSearching(false);
  }

  React.useEffect(() => {
    if (!sites && !teams) {
      return;
    }

    // const treeSites = treeStructureModule.getSites();
    // if (treeSites?.length > 0 && !searchValue && !contentManagerFilterValue) {
    //   setCombinedSitesAndTeams(treeSites);
    // } else {
    let combinedSites: ISiteInfoLocation[] = sites ? [...sites.map((site, index) => ({ ...site, key: "s" + index, randomId: generateRandomString() }))] : [];

    let searchedSites: ISiteInfo[];
    if (siteSearchResult?.sites?.length > 0) {
      searchedSites = siteSearchResult.sites.filter(searchedSite => !sites?.some(site => site.id === searchedSite.id));
      if (searchedSites?.length > 0) {
        combinedSites = combinedSites.concat(searchedSites
          .map((site, index) => {
            return {
              ...site,
              key: `ss ${index} ${generateRandomString()}`,
              randomId: generateRandomString()
            }
          })
        );
      }
    }

    teams?.forEach((team, index) => {
      if (!combinedSites.some(site => site.id === team.siteId)) {
        combinedSites.push({
          id: team.siteId,
          name: team.displayName,
          webUrl: team.webUrl,
          isSubsite: false,
          key: `t ${index} ${generateRandomString()}`,
          teamDriveId: team.driveId,
          teamGroupId: team.id,
          randomId: generateRandomString()
        });
      }
    });

    combinedSites.forEach(site => {
      const team = teams?.find(x => x.siteId === site.siteId || x.siteId === site.id);
      if (team) {
        site.id = team.id;
        site.siteId = team.siteId;
        site.isTeam = true;
        site.isSite = false;
        site.teamDriveId = team.driveId;
        site.teamGroupId = team.id;
        site.isSharedTeam = team.isSharedTeam;
      }
      site.canExpand = true;
      site.expanded = false;
      site.treeType = site.isManagedGroup ? DirectoryTreeType.docubirdGroup : DirectoryTreeType.site;
      site.level = 1;
      site.isLoading = false;
      site.loaded = false;
      site.isSelected = false;
    });

    if (combinedSites?.length > 0) {
      const filterValue: string = searchValue && searchValue.trim() !== ""
        ? searchValue.trim().toLowerCase()
        : contentManagerFilterValue && contentManagerFilterValue.trim() !== "" && String(contentManagerFilterValue.trim().toLowerCase());

      if (filterValue) {
        if (isDocubirdManagedLocation) {
          const filteredResults: ISiteInfoLocation[] = [];
          const managedGroupsToExpand: Set<string> = new Set();

          for (const site of combinedSites) {
            const siteMatchesFilter = site.name?.toLowerCase()?.includes(filterValue);

            if (siteMatchesFilter) {
              if (site.managedGroup) {
                managedGroupsToExpand.add(site.managedGroup);
              }
              filteredResults.push(site);
            }
          }

          const finalFilteredSites: ISiteInfoLocation[] = [];
          const addedSiteIds: Set<string> = new Set();

          for (const site of combinedSites) {
            const isManagedGroupWithMatchingChildren = site.isManagedGroup && managedGroupsToExpand.has(site.id);
            const isDirectlyFiltered = !isManagedGroupWithMatchingChildren && filteredResults.some(s => s.id === site.id);

            if (isManagedGroupWithMatchingChildren && !addedSiteIds.has(site.id)) {
              const managedGroup: ISiteInfoLocation = { ...site, expanded: true, subSites: [] };

              const groupChildren: ISiteInfoLocation[] = filteredResults.filter(s => s.managedGroup === managedGroup.id);

              for (const child of groupChildren) {
                managedGroup.subSites.push({ ...child, level: managedGroup.level + 1 });
                addedSiteIds.add(child.id);
              }

              finalFilteredSites.push(managedGroup);
              addedSiteIds.add(managedGroup.id);
            }
            else if (isDirectlyFiltered && !addedSiteIds.has(site.id)) {
              finalFilteredSites.push(site);
              addedSiteIds.add(site.id);
            }
          }

          combinedSites = finalFilteredSites;
        }
        else {
          combinedSites = combinedSites.filter(site => site.name?.toLowerCase()?.includes(filterValue));
        }
      }
      else {
        combinedSites = combinedSites.filter(site => isDocubirdManagedLocation || (!site.isHubChild && !site.parentHubId));
      }
    }

    setCombinedSitesAndTeams(prevValues => {
      if (combinedSites?.length > 0) {
        let allSites: ISiteInfoLocation[];
        if (searchValue || contentManagerFilterValue || compareWithCachedSites.current === false) {
          allSites = combinedSites;
        }
        else {
          const expandedItems: ISiteInfoLocation[] = prevValues?.filter(item => item.expanded) ?? [];

          if (isDocubirdManagedLocation) {
            for (const expandedItem of expandedItems) {
              if (expandedItem.isManagedGroup && Array.isArray(expandedItem.subSites) && expandedItem.subSites.length > 0) {
                const groupChildrenToAdd: ISiteInfo[] = sites?.filter(s => s.isManaged
                  && !s.isManagedGroup
                  && s.managedGroup === expandedItem.id
                  && !expandedItem.subSites.some(subSite => subSite.id === s.id)
                );

                if (Array.isArray(groupChildrenToAdd) && groupChildrenToAdd.length > 0) {
                  expandedItem.subSites = expandedItem.subSites
                    .concat(groupChildrenToAdd
                      .map(subSite => ({
                        ...subSite,
                        parentId: expandedItem.id,
                        treeType: DirectoryTreeType.site,
                        canExpand: true,
                        level: expandedItem.level + 1,
                        randomId: generateRandomString()
                      }))
                    );
                }
              }
            }
          }

          const newItems: ISiteInfoLocation[] = combinedSites?.filter(site => !expandedItems.some(x => x.id === site.id));
          allSites = expandedItems.concat(newItems);
        }

        if (isDocubirdManagedLocation) {
          return allSites.filter(site => site && site.isManaged && (site.isManagedGroup || !site.managedGroup));
        }
        else {
          return allSites.filter(site => site && !site.isManaged);
        }
      }
      return null;
    });

    compareWithCachedSites.current = true;

  }, [sites, teams, siteSearchResult, searchValue, contentManagerFilterValue, isDocubirdManagedLocation]);

  // React.useEffect(() => {
  //   if (!searchValue && !contentManagerFilterValue) {
  //     treeStructureModule.setSites(combinedSitesAndTeams);
  //   }
  // }, [combinedSitesAndTeams, searchValue, contentManagerFilterValue]);

  React.useEffect(() => {
    allowSiteScroll.current = (combinedSitesAndTeams as any[])?.some(site => site?.expanded
      && (site?.subSites?.some(x => x?.expanded)
        || site?.documents?.some(x => x?.expanded)
        || site?.channels?.some(x => x?.expanded)));
    setLocationHeight(calculateLocationHeight(combinedSitesAndTeams));
    setSiteItems(renderLocationSites(combinedSitesAndTeams));
  }, [combinedSitesAndTeams, isSearching, isDocubirdManagedLocation]);

  const setContextAwareLoading = React.useCallback((isLoading: boolean, contentManagerOnly: boolean = false) => {
    if (!contentManagerOnly) {
      !generalModule.isInConentMangerMode()
        ? isLoading ? incrementAmountOfLoaders() : decrementAmountOfLoaders()
        : setIsContentManagerContentLoading(isLoading);
    }
    else {
      setIsContentManagerContentLoading(isLoading);
    }
  }, []);

  const onTreeItemClick = React.useCallback(async (event: React.SyntheticEvent, treeItem: any) => {
    event.stopPropagation();
    setContextAwareLoading(true);
    try {
      setLocationItem(treeItem, true, undefined);
      const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, treeItem);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
      if (!generalModule.isInConentMangerMode()) setSearch("");
      setWorkingDirectories(directories);
      if (generalModule.isInConentMangerMode()) {
        setContentManagerSearchValue("");
        toggleContentManagerReload();
      }
    } catch (error) {
      logger(error, "SharePointSite.tsx (onTreeItemClick)");
    }
    setContextAwareLoading(false);
  }, [combinedSitesAndTeams, user]);

  const renderLocationSites = (locationSites: ISiteInfoLocation[]) => {
    return locationSites
      ? SharePointSiteHelper.groupAndSortSites(locationSites)
        .map(item => {
          const isTeamSite = teams?.some(team => team.siteId === item.id || team.siteId === item.siteId);
          return isTeamSite && (!userSettings.enableTeams || hideTeamsSitesInSharePoint) ? null : (
            // return !isTeamSite && (
            <div key={item.id}>
              <SiteItem
                item={item}
                isTeamsLocation={false}
                isMobile={isMobile}
                allowScroll={allowSiteScroll.current}
                onSiteClick={addDirectory}
                onExpandCollapseClick={onLocationSitesChevronClicked}
                onOptionsClick={openFolderOptions}
              />
              {item.subSites && item.expanded && renderLocationSites(item.subSites)}

              {item.subSitesNextHref && <div style={{ paddingLeft: (item.level ? item.level + 1 : 1) * 15 + 20 }}>
                {!item.isLoading && <ActionButton onRenderIcon={() => <ChevronDoubleDown20Regular />} allowDisabledFocus onClick={async (e: any) => {
                  e.stopPropagation();
                  setLocationItem(item, undefined, true);

                  try {
                    const level = item.level ? item.level : 0;

                    let accessToken = await authModule.getGraphAccessToken();
                    let subSiteResult = await getSharePointSubsite(accessToken, item.id, allowedSiteCollections, item.subSitesNextHref);

                    const subsites: ISiteInfoLocation[] = subSiteResult?.data?.map(subsite => {
                      return {
                        id: subsite.id,
                        name: subsite.displayName,
                        description: subsite.description,
                        webUrl: subsite.webUrl,
                        isSubsite: true,
                        canExpand: true,
                        expanded: false,
                        parentId: item.id,
                        treeType: DirectoryTreeType.site,
                        level: level + 1,
                        isLoading: false,
                        loaded: false,
                        isSelected: false,
                        randomId: generateRandomString()
                      }
                    })

                    setLocationsSiteSubsiteUpdate(item, [...item.subSites, ...subsites], item.documents, undefined, undefined, true, false, subSiteResult.nextPageLink);

                  } catch (error) {
                    logger(error, "SharePointSite.tsx (subsites load more (getSharePointSubsite))");
                    setLocationItem(location, undefined, false);
                  }
                }}>
                  {languageStrings.LoadMore}
                </ActionButton>}

              </div>}
              {item.subSitesNextHref && item.isLoading && <div style={{ paddingTop: "10px" }}>
                <Spinner size={SpinnerSize.small} />
              </div>}

              {item.channels && item.expanded && renderChannels(item.channels)}
              {item.documents && item.expanded && renderDocuments(item.documents)}
            </div>
          )
        }).filter(item => item)
      : (!searchValue && !isSearching && dataFetchedFromCacheAndRemote
        ? [<div key="0">
          <p className="xb-empty-location-message centerText">{contentManagerFilterValue?.length > 0 ? languageStrings.NoResultsFound : languageStrings.NotAssignedToSite}</p>
        </div>]
        : [])
  };

  const onLocationSitesChevronClicked = async (item: ISiteInfoLocation, isRefresh: boolean = false) => {
    setLocationItem(item, undefined, true);
    try {
      // if (isRefresh || (!item.expanded && (((item.isSite || item.isSubsite) && (!item.documents || item.documents?.length === 0)) || (item.isTeam && (!item.channels || item.channels?.length === 0))))) {
      if (isRefresh || (!item.expanded && !item.loaded)) {
        const level = item.level;

        const accessToken = await authModule.getGraphAccessToken();
        let [subSitesResult, documentLibrariesResult, channelsResult, hubSitesResult] = await Promise.all([
          !item.isSharedTeam && !item.isManagedGroup ? getSharePointSubsite(accessToken, item.isTeam ? item.siteId : item.id, allowedSiteCollections) : { data: [], nextPageLink: null },
          !item.isSharedTeam && !item.isManagedGroup && (!hideDocumentLibrariesInTeams || !item.isTeam) ? getSharePointDocumentLibraries(accessToken, item.isTeam ? item.siteId : item.id, generalModule.isInConentMangerMode()) : [],
          item.isTeam && !item.isManagedGroup && getTeamChannels(accessToken, item.teamGroupId, item.teamDriveId),
          item.isHub && !item.isManagedGroup && getHubSiteSites(accessToken, item.hubId, allowedSiteCollections)
        ]);

        const managedGroupSites = item.isManagedGroup
          ? sites?.filter(s => s.isManaged && !s.isManagedGroup && s.managedGroup === item.id)
          : [];

        let subSites: ISiteInfoLocation[] = [
          ...(subSitesResult?.data ?? []),
          ...(hubSitesResult ?? []).map(hubChild => {
            const teamSite = teams?.find(team => team.siteId === hubChild.siteId || team.siteId === hubChild.id);
            if (teamSite) {
              hubChild.siteId = teamSite.siteId;
              hubChild.isTeam = true;
              hubChild.isSite = false;
              hubChild.teamDriveId = teamSite.driveId;
              hubChild.teamGroupId = teamSite.id;
              hubChild.isSharedTeam = teamSite.isSharedTeam;
            }
            return hubChild;
          }),
          ...managedGroupSites
        ].map(subSite => {
          return {
            ...subSite,
            name: subSite.displayName || subSite.name,
            isSubsite: !subSite.isHub,
            parentId: item.id,
            treeType: DirectoryTreeType.site,
            canExpand: true,
            expanded: false,
            level: level + 1,
            isLoading: false,
            randomId: generateRandomString()
          }
        });

        const sitesConfig = tenantSiteConfig?.filter(siteInfo => siteInfo.displayName?.trim().toLowerCase() === item.name?.trim().toLowerCase());
        const hiddenDocumentLibraries = Array.isArray(sitesConfig) && sitesConfig?.length > 0 ? sitesConfig[0]?.documentLibraries?.filter(docLib => docLib.hidden === true) : [];

        const documents: ISharepointDocumentLocation[] = documentLibrariesResult
          ?.filter(docLib => !hiddenDocumentLibraries.some(hiddenLib => hiddenLib?.title?.trim().toLowerCase() === docLib?.name?.trim().toLowerCase()))
          ?.map(doc => {
            return {
              ...doc,
              parentId: item.id,
              treeType: DirectoryTreeType.document,
              level: level + 1,
              canExpand: true,
              expanded: false,
              isLoading: false,
              randomId: generateRandomString()
            }
          });

        const channels: ITeamChannelLocationDto[] = channelsResult?.map(channel => {
          return {
            ...channel,
            parentId: item.id,
            treeType: DirectoryTreeType.channel,
            isSelected: false,
            key: item.key,
            level: level + 1,
            randomId: generateRandomString(),
            canExpand: true,
            expanded: false,
            loaded: false
          }
        });

        setLocationsSiteSubsiteUpdate(item, subSites, documents, undefined, undefined, false, isRefresh, subSitesResult.nextPageLink, channels);
      }
      else if ((!item.expanded && (item.documents?.length > 0 || item.channels?.length > 0 || item.subSites?.length > 0)) || item.expanded) {
        setLocationsToggleExpanded(item);
      }
    } catch (error) {
      logger(error, "SharePointSite.tsx (renderLocationSites)");
      setLocationItem(item, undefined, false);
    }
  }

  const setLocationsToggleExpanded = (location: any) => {
    setCombinedSitesAndTeams(prevLocations => {
      const recursiveMap = (sites) => {
        return sites.map(site => {
          let updatedSite = site;
          if (site.id === location.id && site.randomId === location.randomId) {
            updatedSite = {
              ...site,
              expanded: !site.expanded,
              isLoading: false,
              isLoadingChannelInfo: false,
            };
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveMap(site.subSites),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveMap(site.documents),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveMap(site.channels),
            };
          }
          if (site.folders) {
            updatedSite = {
              ...updatedSite,
              folders: recursiveMap(site.folders),
            };
          }

          return updatedSite;
        });
      }

      return recursiveMap(prevLocations);
    });
  }

  const setLocationItem = (location: any, isSelected?: boolean, isLoading?: boolean, isLoadingChannelInfo?: boolean) => {
    setCombinedSitesAndTeams((prevLocations) => {
      if (isSelected !== undefined) {
        selectedItem.current = { id: location.id, randomId: location.randomId };
      }
      const recursiveMap = (sites) => {
        return sites.map((site: any) => {
          let updatedSite = site;
          let isCurrentItemSelected =
            selectedItem.current && site.id === selectedItem.current.id && site.randomId === selectedItem.current.randomId;
          if (site.id === location.id && site.randomId === location.randomId) {
            updatedSite = {
              ...site,
              isLoading: isLoading !== undefined ? isLoading : site.isLoading,
              isSelected: isSelected !== undefined ? isSelected : site.isSelected,
              isLoadingChannelInfo: isLoadingChannelInfo !== undefined ? isLoadingChannelInfo : site.isLoadingChannelInfo,
            };
          }
          else if (isCurrentItemSelected) {
            updatedSite = {
              ...site,
              isSelected: isSelected !== undefined ? isSelected : site.isSelected
            };
          }
          else {
            updatedSite = {
              ...site,
              isSelected: false,
            };
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveMap(site.subSites),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveMap(site.documents),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveMap(site.channels),
            };
          }
          if (site.folders) {
            updatedSite = {
              ...updatedSite,
              folders: recursiveMap(site.folders),
            };
          }
          return updatedSite;
        });
      };

      return recursiveMap(prevLocations);
    });
  };

  const setLocationsSiteSubsiteUpdate = (location: any, subsites: ISiteInfoLocation[], documents: ISharepointDocumentLocation[], folders: IFolderLocation[], foldersNextHref: string, isLoadmore: boolean = false, isRefresh: boolean = false, subSitesNextHref: string, channels?: ITeamChannelDto[]) => {
    setCombinedSitesAndTeams(prevLocations => {
      const recursiveFolderUpdate = (items) => {
        return items?.map(item => {
          let updatedItem = item;
          if (item.id === location.id && item.randomId === location.randomId) {
            updatedItem = {
              ...item,
              folders: [...folders],
              foldersNextHref: foldersNextHref ? foldersNextHref : "",
              expanded: (isLoadmore || isRefresh) ? item.expanded : !item.expanded,
              canExpand: folders.length > 0,
              isLoading: false,
              loaded: true,
            };
          }
          else if (item.folders) {
            updatedItem = {
              ...updatedItem,
              folders: recursiveFolderUpdate(item.folders),
            };
          }
          return updatedItem;
        });
      }

      const recursiveUpdate = (sites) => {
        return sites.map(site => {
          let updatedSite = site;
          if (site.id === location.id && site.randomId === location.randomId) {
            updatedSite = {
              ...site,
              subSites: subsites,
              channels: channels,
              subSitesNextHref: subSitesNextHref ? subSitesNextHref : "",
              documents: (isLoadmore || isRefresh) ? [...documents] : [...(site.documents || []), ...documents],
              expanded: (isLoadmore || isRefresh) ? site.expanded : !site.expanded,
              isLoading: false,
              loaded: true,
            };

            return updatedSite;
          }
          if (site.subSites) {
            updatedSite = {
              ...updatedSite,
              subSites: recursiveUpdate(site.subSites),
            };
          }
          if (site.documents) {
            updatedSite = {
              ...updatedSite,
              documents: recursiveFolderUpdate(site.documents),
            };
          }
          if (site.channels) {
            updatedSite = {
              ...updatedSite,
              channels: recursiveFolderUpdate(site.channels)
            };
          }
          return updatedSite;
        });
      }

      // Call recursiveUpdate directly on prevLocations
      return recursiveUpdate(prevLocations);
    });
  }

  const setLocationsChannelUpdate = (location: any, channels: ITeamChannelLocationDto[], folders: IFolderLocation[], foldersNextHref: string, isLoadmore: boolean = false, isRefresh: boolean = false) => {
    setCombinedSitesAndTeams(prevLocations => {
      const recursiveFolderUpdate = (items) => {
        return items.map(item => {
          let updatedItem = item;
          if (item.id === location.id && item.randomId === location.randomId) {
            updatedItem = {
              ...item,
              folders: [...folders || []],
              foldersNextHref: foldersNextHref ? foldersNextHref : "",
              expanded: (isLoadmore || isRefresh) ? item.expanded : !item.expanded,
              canExpand: folders.length > 0,
              isLoading: false,
              loaded: true,
            };

            return updatedItem;
          }
          else if (item.folders) {
            updatedItem = {
              ...updatedItem,
              folders: recursiveFolderUpdate(item.folders),
            };
          }
          return updatedItem;
        });
      }

      return prevLocations.map(prevLocation => {
        if (prevLocation.id === location.id && prevLocation.randomId === location.randomId) {
          return {
            ...prevLocation,
            channels: channels,
            expanded: isRefresh ? prevLocation.expanded : !prevLocation.expanded,
            isLoading: false,
            loaded: true,
          };
        }
        if (prevLocation.channels) {
          return {
            ...prevLocation,
            channels: recursiveFolderUpdate(prevLocation.channels),
          };
        }
        else {
          return prevLocation;
        }
      });
    });
  }

  const isValidDropZone = React.useMemo((): boolean => {
    return validSaveModes.some(item => item === mode) || generalModule.isInConentMangerMode();
  }, [mode]);

  const handleSaveClick = React.useCallback(async (item, e) => {
    e.preventDefault();
    e.stopPropagation();
    e.persist();

    setContextAwareLoading(true);

    try {
      const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, item);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
      const currentDir = directories[directories.length - 1];
      const parent = newWorkingDirectories.find(x => x.id === item.parentId);

      var folderViewWrapper = new FolderViewWrapper(parent.subSites, { ...currentDir, DocumentLibrary: item.name, sharePointListId: item.sharePointListId });
      const canViewFolder = folderViewWrapper.canViewFolder();
      const accessToken = await authModule.getSharePointAccessToken();
      const webUrl = currentDir?.webUrl;
      const [settings, permissions] = await Promise.all([
        getListSettings(accessToken, webUrl, item.sharePointListId),
        getUserEffectivePermissions(accessToken, webUrl, item.sharePointListId)
      ]);

      setCanViewFolder({
        sharepointListId: item.sharePointListId,
        canView: canViewFolder,
        canCreateFolder: canViewFolder ? settings?.EnableFolderCreation : false,
        contentTypesEnabled: settings?.ContentTypesEnabled,
        enableMinorVersions: settings?.EnableMinorVersions,
        disableOpenInApp: settings?.ExcludeFromOfflineClient === true,
        userPermissions: permissions
      });

      savingLocationStructureModule.setSavingLocationStructure(directories);

      if (generalModule.isInConentMangerMode()) {
        generalModule.setOpenPanelUploadPanel(true);
        setWorkingDirectories(directories);
        setContentManagerSearchValue("");
        toggleContentManagerReload();
      } else {
        const savingDirectory = {
          ...directories[directories.length - 1],
          isSaveLocationStructureSet: true,
          displayName: languageStrings.Properties,
          type: ComponentTypes.Saving
        }

        const newLocations = [
          ...directories,
          savingDirectory,
        ];

        setWorkingDirectories(newLocations);
      }
    } catch (error) {
      logger(error, "TaskpaneDialog.ts (handleSaveClick)");
    }

    setSearch("");
    setContextAwareLoading(false);
  }, [combinedSitesAndTeams, user]);

  const onChannelSaveClicked = React.useCallback(async (event: React.SyntheticEvent, item: ITeamChannelLocationDto, isSaveRequest: boolean = false) => {
    if (isSaveRequest) {
      event.preventDefault();
      event.stopPropagation();

      setContextAwareLoading(true);

      try {
        const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, item);
        const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);

        savingLocationStructureModule.setSavingLocationStructure(directories);

        if (generalModule.isInConentMangerMode()) {
          generalModule.setOpenPanelUploadPanel(true);
          setWorkingDirectories(directories);
        } else {
          const savingDirectory = {
            ...directories[directories.length - 1],
            isSaveLocationStructureSet: true,
            displayName: languageStrings.Properties,
            type: ComponentTypes.Saving
          }

          const newLocations = [
            ...directories,
            savingDirectory,
          ];

          setWorkingDirectories(newLocations);
        }
      } catch (error) {
        logger(error, "SharePointSite.tsx (onChannelSaveClicked)");
      }

      setContextAwareLoading(false);
    }
  }, [combinedSitesAndTeams, user]);

  const onFolderSaveClicked = React.useCallback(async (item: any, e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.persist();

    setContextAwareLoading(true);

    try {
      const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, item);
      const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);

      savingLocationStructureModule.setSavingLocationStructure(directories);

      if (generalModule.isInConentMangerMode()) {
        generalModule.setOpenPanelUploadPanel(true);
        setWorkingDirectories(directories);
      } else {
        const savingDirectory = {
          ...directories[directories.length - 1],
          isSaveLocationStructureSet: true,
          displayName: languageStrings.Properties,
          type: ComponentTypes.Saving
        }

        const newLocations = [
          ...directories,
          savingDirectory,
        ];

        setWorkingDirectories(newLocations);
      }
    } catch (error) {
      logger(error, "SharePointSite.tsx (onFolderSaveClicked)");
    }

    setContextAwareLoading(false);
  }, [combinedSitesAndTeams, user]);

  const renderDocuments = (documents: ISharepointDocumentLocation[]) => {
    return documents.map((document, index) => (
      <div key={`${document.id}-${index}`}>
        <SharePointDocumentLibraryItem
          key={index}
          treeItem={document}
          isMobile={isMobile}
          isValidDropZone={isValidDropZone && !document.isList}
          allowScroll
          getTreeLocations={getTreeLocations}
          hasFileSelected={hasFileSelected}
          handleSaveClick={handleSaveClick}
          onTreeItemClick={onTreeItemClick}
          openFolderOptionsTree={async (e) => {
            e.stopPropagation();
            setFolderOptionPanelInfo(await openTreeFolderOptions(combinedSitesAndTeams, document, user));
          }}
          onTreeExpand={async (isRefresh) => {
            // if (isRefresh || (!document.expanded && (!document.folders || document.folders?.length === 0))) {
            if (isRefresh || (!document.expanded && !document.loaded)) {
              setLocationItem(document, undefined, true);
              try {
                const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, document);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                const level = document.level;
                let folders: IFolderLocation[] = [];

                const results = await getListAsStreamTree({
                  siteUrl: currDirectory.webUrl,
                  sharePointListId: currDirectory.sharePointListId,
                  accessToken: await authModule.getSharePointAccessToken(),
                  nextPageUrl: "",
                  serverRelativePath: ""
                });

                const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                  folders = results?.data?.ListData?.Row.map(row => {
                    const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                    const spItemUrlparts = row['.spItemUrl'].split('/');
                    const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                    const driveId = spItemUrlparts[spItemUrlparts.length - 3];


                    return {
                      id: itemId,
                      name: row.FileLeafRef,
                      level: level + 1,
                      driveId,
                      sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                      contentTypeId: row.ContentTypeId,
                      path: row.FileRef,
                      canExpand: folderChildCount > 0,
                      expanded: false,
                      isLoading: false,
                      webUrl: currDirectory.webUrl,
                      sharePointListId: currDirectory.sharePointListId,
                      treeType: DirectoryTreeType.folder,
                      randomId: generateRandomString(),
                      canRefresh: true
                    }
                  })
                }

                setLocationsSiteSubsiteUpdate(document, undefined, undefined, folders, foldersNextHref, false, isRefresh, undefined);

              } catch (error) {
                logger(error, "SharePointSite.ts (renderDocuments(getListAsStreamTree))");
              }
              setLocationItem(document, undefined, false);
            }
            else if ((!document.expanded && document.folders?.length > 0) || document.expanded) {
              setLocationsToggleExpanded(document);
            }
          }}
        />
        {document.folders && document.expanded && renderFolders(document.folders, document)}
      </div>
    ));
  };

  const renderChannels = (channels: ITeamChannelLocationDto[]) => {
    return channels.map((channel, index) => (
      <div key={`${channel.id}-${index}`}>
        <TeamChannelItem
          key={index}
          treeItem={channel}
          isMobile={isMobile}
          isValidDropZone={isValidDropZone}
          hasFileSelected={hasFileSelected}
          allowScroll
          getTreeLocations={getTreeLocations}
          inSharepointComponent={true}
          onChannelClicked={onChannelSaveClicked}
          onTreeItemClick={onTreeItemClick}
          openFolderOptionsTree={async (e) => {
            e.stopPropagation();
            setLocationItem(channel, undefined, undefined, true);
            setFolderOptionPanelInfo(await openTreeFolderOptions(combinedSitesAndTeams, channel, user));
            setLocationItem(channel, undefined, undefined, false);
          }}
          onTreeExpand={async (isRefresh) => {
            // if (isRefresh || (!channel.expanded && (!channel.folders || channel.folders?.length === 0))) {
            if (isRefresh || (!channel.expanded && !channel.loaded)) {
              setLocationItem(channel, undefined, true);
              try {
                const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, channel);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                const domain = new URL(currDirectory.webUrl).origin;

                const level = channel.level;
                let folders: IFolderLocation[] = [];

                const results = await getListAsStreamTree({
                  siteUrl: currDirectory.webUrl,
                  sharePointListId: currDirectory.sharePointListId,
                  accessToken: await authModule.getSharePointAccessToken(),
                  nextPageUrl: "",
                  serverRelativePath: currDirectory.directory ? `${currDirectory.webUrl.replace(domain, "")}/${currDirectory.directory}` : ""
                });

                const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                  folders = results?.data?.ListData?.Row.map(row => {
                    const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                    const spItemUrlparts = row['.spItemUrl'].split('/');
                    const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                    const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                    return {
                      id: itemId,
                      name: row.FileLeafRef,
                      level: level + 1,
                      driveId,
                      sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                      contentTypeId: row.ContentTypeId,
                      path: row.FileRef,
                      canExpand: folderChildCount > 0,
                      expanded: false,
                      isLoading: false,
                      webUrl: currDirectory.webUrl,
                      sharePointListId: currDirectory.sharePointListId,
                      treeType: DirectoryTreeType.folder,
                      randomId: generateRandomString(),
                      canRefresh: true
                    }
                  })
                }
                setLocationsChannelUpdate(channel, undefined, folders, foldersNextHref, false, isRefresh);
              } catch (error) {
                logger(error, "Teams.tsx (renderChannels(getListAsStreamTree))");
              }
              setLocationItem(channel, undefined, false);
            }
            else if ((!channel.expanded && channel.folders?.length > 0) || channel.expanded) {
              setLocationsToggleExpanded(channel);
            }

          }}
        />
        {channel.folders && channel.expanded && renderFolders(channel.folders, channel)}
      </div>
    ));
  };

  const renderFolders = (folders: IFolderLocation[], location: any) => {
    return (
      <div>
        {folders.map((folder, index) => (
          <div key={`${folder.id}-${index}`}>
            <SharePointFolderItem
              key={index}
              treeItem={folder}
              isMobile={isMobile}
              hasFileSelected={hasFileSelected}
              isValidDropZone={isValidDropZone}
              allowScroll
              getTreeLocations={getTreeLocations}
              onTreeItemClick={onTreeItemClick}
              onSaveClicked={onFolderSaveClicked}
              openFolderOptionsTree={async (e) => {
                e.stopPropagation();
                setLocationItem(folder, undefined, undefined, true);
                setFolderOptionPanelInfo(await openTreeFolderOptions(combinedSitesAndTeams, folder, user));
                setLocationItem(folder, undefined, undefined, false);
              }}
              onTreeExpand={async (isRefresh) => {
                // if (isRefresh || (!folder.expanded && (!folder.folders || folder.folders?.length === 0))) {
                if (isRefresh || (!folder.expanded && !folder.loaded)) {
                  setLocationItem(folder, undefined, true);
                  try {
                    const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, folder);
                    const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                    const currDirectory = directories[directories.length - 1];

                    const level = folder.level;
                    let subFolders: IFolderLocation[] = [];

                    const results = await getListAsStreamTree({
                      siteUrl: folder.webUrl,
                      sharePointListId: folder.sharePointListId,
                      accessToken: await authModule.getSharePointAccessToken(),
                      nextPageUrl: "",
                      serverRelativePath: folder.path
                    });

                    const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                    if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                      subFolders = results?.data?.ListData?.Row.map(row => {
                        const folderChildCount = row.FolderChildCount ? +row.FolderChildCount : 0;

                        const spItemUrlparts = row['.spItemUrl'].split('/');
                        const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                        const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                        return {
                          id: itemId,
                          name: row.FileLeafRef,
                          level: level + 1,
                          driveId,
                          sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                          contentTypeId: row.ContentTypeId,
                          path: row.FileRef,
                          canExpand: folderChildCount > 0,
                          expanded: false,
                          isLoading: false,
                          webUrl: currDirectory.webUrl,
                          sharePointListId: currDirectory.sharePointListId,
                          treeType: DirectoryTreeType.folder,
                          randomId: generateRandomString(),
                          canRefresh: true
                        }
                      })
                    }

                    setLocationsSiteSubsiteUpdate(folder, undefined, undefined, subFolders, foldersNextHref, false, isRefresh, undefined);

                  } catch (error) {
                    logger(error, "SharePointSite.ts (renderFolders(getListAsStreamTree))");
                  }
                  setLocationItem(folder, undefined, false);
                }
                else if ((!folder.expanded && folder.folders?.length > 0) || folder.expanded) {
                  setLocationsToggleExpanded(folder);
                }
              }}
            />

            {index === folders.length - 1 && location.foldersNextHref && <div style={{ paddingLeft: (location.level ? location.level + 1 : 1) * 15 + 20 }}>
              {!location.isLoading && <ActionButton onRenderIcon={() => <ChevronDoubleDown20Regular />} allowDisabledFocus onClick={async (e: any) => {
                e.stopPropagation();
                setLocationItem(location, undefined, true);
                const newWorkingDirectories = findWorkingDirectories(combinedSitesAndTeams, location);
                const { directories } = await buildWorkingDirectoryFromTree(newWorkingDirectories, user);
                const currDirectory = directories[directories.length - 1];

                const domain = new URL(currDirectory.webUrl).origin

                try {
                  const level = location.level ? location.level : 0;
                  let folders: IFolderLocation[] = [];

                  const inOneDrive = location.isOneDrive;
                  const webUrl = currDirectory.webUrl;
                  const sharePointListId = currDirectory.sharePointListId;

                  const results = await getListAsStreamTree({
                    siteUrl: webUrl,
                    sharePointListId,
                    accessToken: await authModule.getSharePointAccessToken(),
                    nextPageUrl: location.foldersNextHref,
                    serverRelativePath: currDirectory.serverRelativePath
                  });

                  const foldersNextHref = results?.data?.ListData?.NextHref ? results?.data?.ListData?.NextHref : "";

                  if (results?.data?.ListData?.Row && results?.data?.ListData?.Row.length > 0) {
                    folders = results?.data?.ListData?.Row.map(row => {
                      const spItemUrlparts = row['.spItemUrl'].split('/');
                      const itemId = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
                      const driveId = spItemUrlparts[spItemUrlparts.length - 3];

                      return {
                        id: itemId,
                        name: row.FileLeafRef,
                        level: level + 1,
                        driveId,
                        sharePointUniqueId: row.UniqueId.replace("{", "").replace("}", ""),
                        contentTypeId: row.ContentTypeId,
                        path: row.FileRef,
                        canExpand: true,
                        expanded: false,
                        isLoading: false,
                        webUrl,
                        sharePointListId,
                        isOneDrive: inOneDrive,
                        treeType: DirectoryTreeType.folder,
                        randomId: generateRandomString(),
                        canRefresh: true
                      }
                    })
                  }

                  setLocationsSiteSubsiteUpdate(location, undefined, undefined, [...location.folders, ...folders], foldersNextHref, true, false, undefined);

                } catch (error) {
                  logger(error, "Locations.tsx (renderChannels(getListAsStreamTree))");
                  setLocationItem(location, undefined, false);
                }
              }}>
                {languageStrings.LoadMore}
              </ActionButton>}

            </div>}
            {index === folders.length - 1 && location.foldersNextHref && location.isLoading && <div style={{ paddingTop: "10px" }}>
              <Spinner size={SpinnerSize.small} />
            </div>}

            {folder.folders && folder.expanded && renderFolders(folder.folders, folder)}
          </div>
        ))}
      </div>
    )
  };

  const dismissFolderOptionPanel = React.useCallback(() => {
    setFolderOptionPanelInfo(initialFolderOptionPanelInfoSetting);
  }, []);

  const loadMoreSitesButton = (
    ((!searchValue && !contentManagerFilterValue && sitesPageData?.moreResultsAvailable) || siteSearchResult?.pageData.moreResultsAvailable) &&
    (
      isSitesLoading || isSearching ? (
        <div style={{ paddingBottom: "10px" }}>
          <Spinner size={SpinnerSize.medium} />
        </div>
      ) : (
        // <ActionButton
        //   styles={{ root: { marginLeft: 40 } }}
        //   iconProps={{ iconName: "Table" }}
        //   allowDisabledFocus
        //   onClick={async () => siteSearchResult?.pageData.moreResultsAvailable ? await searchSites(generalModule.isInConentMangerMode() ? contentManagerFilterValue : searchValue, siteSearchResult?.pageData) : await loadMoreSites()}
        // >
        //   {languageStrings.LoadMore}
        // </ActionButton>
        <ActionButton
          onRenderIcon={() => <ChevronDoubleDown20Regular />}
          allowDisabledFocus
          onClick={async () => siteSearchResult?.pageData.moreResultsAvailable ? await searchSites(generalModule.isInConentMangerMode() ? contentManagerFilterValue : searchValue, siteSearchResult?.pageData) : await loadMoreSites()}
        >
          {languageStrings.LoadMore}
        </ActionButton >
      )
    )
  );

  return amountOfLoaders > 0 || isLoading || ((!siteItems || siteItems?.length === 0) && !dataFetchedFromCacheAndRemote) ? (
    <Loader hide={hide} />
  ) : (
    <div className={hide ? "none" : (!isGeneralSearchRequest ? "fullHeight" : undefined)}>
      {(!searchValue || (!isSearchingContent && !isSearchingFilesAndFolders && siteItems?.length > 0)) && <ExpanderWithSubtitle
        items={siteItems}
        title={languageStrings.Sites}
        expanderNameToToggle={expanderConstants.sharepoint.sites}
        extra={loadMoreSitesButton}
        hasShowMoreButton={searchValue && isFileOrFolderSearchResultsAvailable}
        fixedHeight={locationHeight}
        isWaitingOnContent={isSearching || isReloading}
        allowScroll={allowSiteScroll.current}
        actionButton={generalModule.isInConentMangerMode() &&
          <SubTitleRefreshButton
            onClick={async () => {
              setIsReloading(true);
              compareWithCachedSites.current = false;
              await Promise.all([getSites(allowedSiteCollections, null, true, false), getTeams(true, false)]);
              setIsReloading(false);
            }}
          />
        }
      />}
      {folderOptionPanelInfo?.isOpen && <FolderOptionPanel info={folderOptionPanelInfo} dismissPanel={dismissFolderOptionPanel} />}
      {!hide && !isGeneralSearchRequest && searchValue && <FileAndFoldersSharepointSearch parentViewHasItems={isSearching || siteItems?.length > 0} isSearchingCallback={(isSearching: boolean) => setIsSearchingContent(isSearching)} searchResultsAvailableCallback={UpdateIsFileOrFolderSearchResultsAvailable} isLoadingCallback={(isLoading: boolean) => setIsLoading(isLoading)} />}
    </div>
  );
};

export default React.memo(connector(SharePointSite));
